import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {withReportTable} from 'views/Workspace/Examination/renderReportTable'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {course_getCourseStudentResultsReport_Api} from "../../../../apis";
import Translate from "../../../../modules/local/Translate";
import {ifThenElseMultipleConditions} from "../../../../helpers/ifThenElseMultipleConditions";
import {CourseStudentResultReportFilter} from "../components/filters/CourseStudentResultReportFilter";
import {renderReportRow} from "../../Examination/renderReportTable";
import {GoDotFill} from "react-icons/go";
import getAliasName from "../../../../helpers/getAliasName";
import {renderIf, renderIfElse} from "../../../Shared";
import DrawDialog from "../../../../components/drawer/dialog/DrawDialog";
import {BsFillQuestionCircleFill} from "react-icons/bs";
import {HeaderWithIconLine} from "../../../AppLocals/Templates/items/ListHeader";
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {formatDate} from "../../../../helpers/datetimeHelpers";

const TableWrapper = ({children, headers = []}) => {
    const t = useTranslate()
    const content = useMemo(
        () =>
            Array.from(headers).map((title, index) => (
                <th
                    key={index}
                    className="px-2 py-1 font-medium text-xs text-blue-600 italic capitalize">
                    {t(title).replace('?', '')}
                </th>
            )),
        [headers]
    )
    return (
        <table className="custom-table-in-table m-1">
            <thead>
            <tr>{content}</tr>
            </thead>
            <tbody>
            {children}
            </tbody>
        </table>
    )
}

const headers = [
    'fullname',
    'subject results',
    'results',
]

const detailHeaders = [
    'subject name',
    'cc_percent',
    'score weight',
    'score',
    'status',
]

const detailSchemas = [
    {
        name: 'subject_name',
        value_path: 'subject_name',
        className: 'flex items-start justify-start',
        render: (value) => (
            <div className="flex items-center gap-1 whitespace-no-wrap">
                <GoDotFill size={9} className="text-color-500"/>
                <span className="font-bold text-xs text-color-100">
                    {value}
                </span>
            </div>
        ),
    },
    {
        name: 'cc_percent',
        value_path: 'cc_percent',
        className: 'text-color-100',
        render: (value, data) => (
            <Translate>
                {t => (
                    renderIfElse(
                        value === null || value === undefined,
                        <span className="font-normal text-xs text-color-400 italic capitalize">{t('not update')}</span>,
                        <span className="font-semibold text-xs text-color-000">{`${value} %`}</span>
                    )
                )}
            </Translate>
        ),
    },
    {
        name: 'score_weight',
        value_path: 'score_weight',
        className: 'text-color-200',
        render: (value, data) => <span className="text-xs">{value}</span>,
    },
    {
        name: 'score',
        value_path: 'score_number',
        className: 'text-color-100',
        render: (value, data) => {
            let score = value;
            switch (_.get(data, 'score_type')) {
                case "text":
                    score = _.get(data, 'score_text')
                    break;
                default:
                    score = _.get(data, 'score_number')
                    break;
            }
            return (
                <Translate>
                    {t => (
                        renderIfElse(
                            value === null || value === undefined,
                            <span
                                className="font-normal text-xs text-color-400 italic capitalize">{t('not update')}</span>,
                            <div className="flex flex-center space-x-2">
                                <span className="font-semibold text-xs text-color-000">{value}</span>
                                <DrawDialog
                                    width={600}
                                    title={
                                        <div className="text-center font-bold text-color-000 tracking-wider">
                                            {t('grades')}
                                        </div>
                                    }
                                    closable={true}
                                    component={<BsFillQuestionCircleFill
                                        className="text-color-400 hover:text-color-100 cursor-pointer"/>}>
                                    {(isToggle, toggle) => isToggle && (
                                        <div className="flex flex-col gap-2">
                                            <HeaderWithIconLine
                                                title="list of grades"
                                                className="text-sm text-color-400"
                                            />
                                            <div className="ml-1 space-y-3">
                                                {_.get(data, 'grades').map((e, i) => {
                                                    const {
                                                        grade_title,
                                                        score_type,
                                                        score_number,
                                                        score_1_number,
                                                        score_2_number,
                                                        score_text,
                                                        score_1_text,
                                                        score_2_text,
                                                        grade_date,
                                                        grade_1_date,
                                                        grade_2_date,
                                                    } = e ?? {}

                                                    return (
                                                        <div key={i}
                                                             className="py-1 flex flex-col gap-1 custom-render-border">
                                                            <span
                                                                className="font-bold text-sm text-color-000 leading-snug">{grade_title}</span>
                                                            <div
                                                                className="grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
                                                                <DoubleValueItem
                                                                    showIcon={true}
                                                                    labelFirst={`${t('score times')} 1`}
                                                                    valueFirst={renderIfElse(
                                                                        score_type === 'text',
                                                                        score_text,
                                                                        score_number
                                                                    )}
                                                                    labelSecond=" - "
                                                                    valueSecond={formatDate(grade_date, 'DD/MM/YYYY')}
                                                                    className="text-xs italic"
                                                                />
                                                                {renderIf(
                                                                    grade_1_date,
                                                                    <DoubleValueItem
                                                                        showIcon={true}
                                                                        labelFirst={`${t('score times')} 2`}
                                                                        valueFirst={renderIfElse(
                                                                            score_type === 'text',
                                                                            score_1_text,
                                                                            score_1_number
                                                                        )}
                                                                        labelSecond=" - "
                                                                        valueSecond={formatDate(grade_1_date, 'DD/MM/YYYY')}
                                                                        className="text-xs italic"
                                                                    />
                                                                )}
                                                                {renderIf(
                                                                    grade_2_date,
                                                                    <DoubleValueItem
                                                                        showIcon={true}
                                                                        labelFirst={`${t('score times')} 3`}
                                                                        valueFirst={renderIfElse(
                                                                            score_type === 'text',
                                                                            score_2_text,
                                                                            score_2_number
                                                                        )}
                                                                        labelSecond=" - "
                                                                        valueSecond={formatDate(grade_2_date, 'DD/MM/YYYY')}
                                                                        className="text-xs italic"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </DrawDialog>
                            </div>
                        )
                    )}
                </Translate>
            )
        },
    },
    {
        name: 'result_status',
        value_path: 'result_status',
        className: 'text-color-100 flex flex-center',
        render: (value, data) => (
            <Translate>
                {t => (
                    <div>
                        {ifThenElseMultipleConditions(
                            <span
                                className="font-normal text-xs text-color-400 italic capitalize">{t('not update')}</span>,
                            value === 1, <span
                                className="font-semibold text-xs text-green-600 capitalize">{t('passed')}</span>,
                            value === 0, <span
                                className="font-medium text-xs text-primary-400 capitalize">{t('failed')}</span>,
                            value === -1, <span className="text-xs text-color-300 capitalize">{t('pending')}</span>
                        )}
                    </div>
                )}
            </Translate>
        ),
    },
]

const schemas = [
    {
        name: 'fullname',
        // value_path: 'student.fullname',
        className: "flex items-start justify-start",
        render: (value, data) => {
            const {student} = data ?? {}
            return (
                <Translate>
                    {t => (
                        <div className="space-x-1 text-sm">
                            <span className="font-medium text-xs text-color-100 italic">
                                {getAliasName(student, 'patron_saint')}.
                            </span>
                            <span className="font-bold text-color-000">
                                {student?.fullname}
                            </span>
                        </div>
                    )}
                </Translate>
            )
        },
    },
    {
        name: 'subject_results',
        value_path: 'subject_results',
        className: 'text-color-100',
        render: (value, data) => {
            return (
                <TableWrapper headers={detailHeaders}>
                    {value.map((e, i) => {
                        return renderReportRow({
                            fields: detailSchemas,
                        })(e, i)
                    })}
                </TableWrapper>
            )
        },
    },
    {
        name: 'result_status',
        value_path: 'result_status',
        render: (value) => (
            <Translate>
                {(t) => (
                    <div className="ml-1 space-y-1 mt-1">
                        {ifThenElseMultipleConditions(
                            <span
                                className="font-normal text-xs text-color-400 italic capitalize">{t('not update')}</span>,
                            value === 1, <span className="font-bold text-sm text-green-600">{t('passed')}</span>,
                            value === 0, <span className="font-medium text-sm text-primary-500">{t('failed')}</span>,
                            value === -1, <span className="text-sm text-color-300">{t('pending')}</span>
                        )}
                    </div>
                )}
            </Translate>
        ),
    },
]

const CourseStudentResultReport = ({
                                       owner_id,
                                       owner_type,
                                       filter_actions = {
                                           sortBy: 'sort-by',
                                           keyword: 'keyword',
                                           course_id: 'course-id',
                                           subject_id: 'subject-id',
                                           course_class_id: 'class-id',
                                       },
                                   }) => {
    const t = useTranslate()

    const location = useLocation()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const course_id = useRouteSearchParam(filter_actions.course_id)

    const course_class_id = useRouteSearchParam(filter_actions.course_class_id)

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, location.state]
    )

    const [pager_widget, {widget_header}] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                course_id,
                course_class_id,
            })
        },
        pagerInfo: {
            query: bindQueryParams([
                {
                    id: course_id,
                }
            ]),
            PaginationMeta: NullAsDefault,
            apiInfo: course_getCourseStudentResultsReport_Api,
            ...withReportTable(headers, schemas),
        },
        withValues: (values) => ({
            course_class_id
        }),
        withKey: createPagerKey(refresh_deps),
        dependencies: [owner_id, owner_type],
        filter_params: {
            owner_id,
            owner_type,
            course_id,
            course_class_id,
        },
        renderSortBy: NullAsDefault,
        SortByWidget: NullAsDefault,
        renderSearchBar: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        AdvancedFilter: CourseStudentResultReportFilter,
    })

    return (
        <div className="space-y-3">
            <div className="font-semibold text-primary tracking-wide uppercase">
                {t('report')}
            </div>
            <div className="border rounded-lg p-3">
                <div className="flex flex-col">
                    <div className="text-center font-bold text-lg text-color-000 uppercase tracking-widest mb-4">
                        {t('final result statistics by subject')}
                    </div>
                    {course_class_id ? pager_widget : widget_header}
                </div>
            </div>
        </div>
    )
}

export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(CourseStudentResultReport)
